import React from 'react';
import classNames from 'classnames';

import './styles.css';
import Icon from '../../../../components/Icon';

class OperationalDashboardCard extends React.Component {
  state = {
    isOpen: true,
  }

  _toogleContent = () => this.setState({ isOpen: !this.state.isOpen })

  render() {
    const {
      isOpen,
    } = this.state;
    const {
      title,
      children,
      fullWidth,
      direction,
      heightAuto
    } = this.props;

    return (
      <div className={classNames('OperationalDashboard__card__padding', 'OperationalDashboard__card', { 'col-md-6': !fullWidth }, { 'col-md-12': fullWidth }, {'OperationalDashboard__height-auto': heightAuto})}>
        <div className="OperationalDashboard__header">
          <p>{title}</p>
          <Icon
            onClick={this._toogleContent}
            className="OperationalDashboard__header__icon"
            name={isOpen ? 'expand_less' : 'expand_more'}
          />
        </div>
        {isOpen &&
        <div className={classNames("OperationalDashboard__container", {[`OperationalDashboard__${direction}`]: direction})}>
          {children}
        </div>}
      </div>
    );
  }
}

export default OperationalDashboardCard;
